import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHeading, EASE } from "@/components/shared";
import { FAQ } from "@/data/content";
import { waLink } from "@/lib/site";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-navy-900/40 py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-[1fr_1.6fr] lg:px-8">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <SectionHeading
            eyebrow="FAQ"
            title={<>Perguntas <span className="text-gold-grad">frequentes</span></>}
          />
          <Reveal delay={0.2}>
            <div className="mt-8 border border-gold/25 bg-navy-800/60 p-6">
              <p className="font-display text-xl font-bold uppercase tracking-wide text-white">
                Ficou com dúvida?
              </p>
              <p className="mt-2 text-sm text-slate-400">Fale diretamente com um engenheiro da nossa equipe.</p>
              <a
                href={waLink("Olá! Tenho uma dúvida sobre os serviços da Realiza Engenharia.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="faq-cta-whatsapp"
                className="mt-5 inline-block rounded-full bg-gold px-6 py-3 font-display text-sm font-bold tracking-[0.14em] text-navy-950 transition-colors hover:bg-gold-bright"
              >
                FALAR COM UM ENGENHEIRO
              </a>
            </div>
          </Reveal>
        </div>
        <div className="space-y-3">
          {FAQ.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.q} delay={i * 0.04}>
                <div
                  data-testid={`faq-item-${i}`}
                  className={`border transition-colors duration-300 ${isOpen ? "border-gold/40 bg-navy-800/60" : "border-white/[0.08] bg-white/[0.02] hover:border-gold/25"}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-trigger-${i}`}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className={`font-display text-lg font-bold uppercase leading-snug tracking-wide transition-colors ${isOpen ? "text-gold" : "text-white"}`}>
                      {item.q}
                    </span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3 }} className={`shrink-0 ${isOpen ? "text-gold" : "text-slate-500"}`}>
                      <Plus className="h-5 w-5" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: EASE }}
                        className="overflow-hidden"
                      >
                        <p className="px-6 pb-6 text-sm leading-relaxed text-slate-400">{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
